import { render, staticRenderFns } from "./ValueEditDialog.vue?vue&type=template&id=65067f1a&scoped=true"
import script from "./ValueEditDialog.vue?vue&type=script&lang=js"
export * from "./ValueEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65067f1a",
  null
  
)

export default component.exports